// src/admincomponents/Dashboard.js
import React, { useState, useEffect } from 'react';
import { apiClient } from '../../api/apiClient';
import UserTable from './UserTable'; // 将引入 UserTable
import { Panel, PanelHeader, PanelTitle, MetaText, StatusText, ErrorNote } from './adminStyles';

function Dashboard({ user }) {
    const [users, setUsers] = useState([]);
    const [allPermissions, setAllPermissions] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchData = async () => {
        try {
            setLoading(true);
            const [usersResponse, permissionsResponse] = await Promise.all([
                apiClient.get('/admin/users'),
                apiClient.get('/admin/permissions')
            ]);
            setUsers(usersResponse.data);
            setAllPermissions(permissionsResponse.data);
            setError('');
        } catch (err) {
            // 检查是否是权限错误
            if (err.response?.status === 403) {
                setError(err.response.data.message || '您暂无权限查看本面板');
            } else {
                setError('数据加载失败，请稍后重试');
            }
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    

    useEffect(() => {
        fetchData();
    }, []);

    const handleUserAdded = (newUser) => {
        setUsers([...users, newUser].sort((a, b) => a.id - b.id));
    };

    const handleUserUpdated = (updatedUser) => {
        setUsers(users.map(u => (u.id === updatedUser.id ? updatedUser : u)));
    };
    
    const handleUserDeleted = (userId) => {
        setUsers(users.filter(u => u.id !== userId));
    };

    return (
        <Panel>
            <PanelHeader>
                <PanelTitle>用户管理</PanelTitle>
                <MetaText>
                    <div>当前登录 <b>{user.username}</b></div>
                    <div>角色 <code>{user.role}</code></div>
                </MetaText>
            </PanelHeader>

            <section>
                {loading && <StatusText>载入中…</StatusText>}
                {error && <ErrorNote role="alert">{error}</ErrorNote>}

                {!loading && !error && (
                    <UserTable
                        users={users}
                        currentUser={user}
                        allPermissions={allPermissions}
                        onUserAdded={handleUserAdded}
                        onUserUpdated={handleUserUpdated}
                        onUserDeleted={handleUserDeleted}
                    />
                )}
            </section>
        </Panel>
    );
}

export default Dashboard;
